export enum MapTool {
  AREA = 'Area',
  DISTANCE = 'Distance',
  LASSO = 'Lasso',
  PAN = 'Pan',
  POINT = 'Point',
  SEGMENT = 'Segment',
}
